import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedService } from '../../../shared/shared.service';
import { segmentsService } from '../segments.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Logger } from 'angular2-logger/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { PageEvent } from '@angular/material/paginator';
import { UserService } from '../../user/user.service';
import * as XLSX from 'xlsx';
import { environment } from '../../../../environments/environment';
// import * as $ from 'jquery';
//Jquery
declare var jquery: any;
declare var $: any;

@Component({
    selector: 'app-segments',
    templateUrl: './segments.component.html',
    styleUrls: ['./segments.component.scss']
})
export class segmentsComponent implements OnInit, AfterViewInit {
    willDownload = false;
    myFormGroup: FormGroup;
    public form: FormGroup;
    public form2: FormGroup;

    public filter: FormGroup;
    public total_items: number;
    public pag_size: number;
    public pag_number: number;
    public list: any;
    public itemQuantity = [];
    public segments = [];
    selectedCity = [];
    public segmentId: any;
    public dataExcel: any = [];
    public showCantRooms = false;
    public showVideocallTime = false;
    public enableVideocall:boolean = environment.enableVideocall;
    

    public action: any;

    cities: any = [];
    selectedItems: any = [];
    dropdownSettings: any = {};

    ShowFilter = false;
    disabled = false;

    selectStatus = 1;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('closebutton') closebutton;
    @ViewChild('selectDropdown') selectDropdown;

    public dataSource = new MatTableDataSource;

    public displayedColumns = [
        'id',
        'Ubicacion',
        'Nombre',
        'Estado',
        'Videollamada',
        'Conversaciones',
        'TiempoLlamada',
        'Editar',

    ];


    constructor(
        private fb: FormBuilder,
        private spinner: NgxSpinnerService,
        private _sharedService: SharedService,
        private _segmentsService: segmentsService,
        public toastr: ToastsManager,
        private _router: Router,
        private logger: Logger,
        private userService: UserService,
    ) {
        this.form = this.fb.group({
            id: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(60)]],
            ubicacion: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(60)]],
            nombre: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(60)]],
            estado: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(60)]],
            defaultSetting:[true],
            customSetting:[false],
            videollamada:[false],
            cantRooms: [''],
            timeCallHora: [''],
            timeCallMinuto: ['', [Validators.required]],
            timeCallSegundo: [''],
            
        });

        this.filter = this.fb.group({
            textoFiltro: [],
            city: []
        });

        this.setupCheckboxLogic();

        this.pag_size = 10;
        this.pag_number = 1;
    }

    //Structure Commands

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
    }

    ngOnInit() {
        this.getSegments();

    }

    //Functions

    async getSegments() {
        const data = await this._segmentsService.getSegments()
        this.segments = [...data.data.segments];
        this.dataSource = new MatTableDataSource(this.segments);
    }

    newSegment() {
        $('#newSegment').modal('toggle', { backdrop: false });
        $('#newSegment').appendTo("body");
    }

    createSegment() {
        this.spinner.show();

        const hora = ("00" + this.form.value.timeCallHora).slice(-2) + ':' + ("00" + this.form.value.timeCallMinuto).slice(-2) + ':' + ("00" + this.form.value.timeCallSegundo).slice(-2);
        console.log("hora creada ",hora);
        let data = {
            ubicacion: this.form.value.ubicacion,
            tienda: this.form.value.nombre,
            status: '1',
            defaultsetting: this.form.value.defaultSetting,
            videocall: this.form.value.videollamada,
            cantRooms: this.form.value.cantRooms,
            videocallTime: hora,
        };

        this._segmentsService.newsSegments(data).subscribe(
            data => {
                this.spinner.hide();
                if (data.status) {
                    $('#ubicacion').val("");
                    $('#nombre').val("");
                    $('#selectStatus').val('1');
                    this.getSegments();
                    this.toastr.success('El segmento se creo exitosamente.');
                } else {
                    this.toastr.error('Ha ocurrido un error', 'Error');
                }
            }
        )
    }

    setupCheckboxLogic() {
        
        this.form.get('defaultSetting').valueChanges.subscribe(value => {
            if (value) { 
                this.form.get('customSetting').setValue(false, { emitEvent: false });
                this.form.get('videollamada').setValue(false, { emitEvent: false });
            }
            this.showCantRooms = this.form.get('customSetting').value;
            this.showVideocallTime = this.form.get('videollamada').value;
        });

        this.form.get('customSetting').valueChanges.subscribe(value => {
            if (value) { 
                this.form.get('defaultSetting').setValue(false, { emitEvent: false });
                this.form.get('videollamada').setValue(false, { emitEvent: false });
            }
            this.showCantRooms = this.form.get('customSetting').value;
            this.showVideocallTime = this.form.get('videollamada').value;
        });

        this.form.get('videollamada').valueChanges.subscribe(value => {
            if (value) { 
                this.form.get('defaultSetting').setValue(false, { emitEvent: false });
                this.form.get('customSetting').setValue(false, { emitEvent: false });
            }
            this.showCantRooms = this.form.get('customSetting').value;
            this.showVideocallTime = this.form.get('videollamada').value;
        });
        
    }

    updateSegment() {
        this.spinner.show();
        const hora = ("00" + this.form.value.timeCallHora).slice(-2) + ':' + ("00" + this.form.value.timeCallMinuto).slice(-2) + ':' + ("00" + this.form.value.timeCallSegundo).slice(-2);

        if (this.form.value.estado == 1) {
            this.selectStatus = 1;
        } else {
            this.selectStatus = 0;
        }

        let data = {
            id: this.form.value.id,
            ubicacion: this.form.value.ubicacion,
            tienda: this.form.value.nombre,
            status: this.selectStatus.toString(),
            defaultSetting: this.form.value.defaultSetting ? 1 : 0 ,
            customSetting: this.form.value.defaultSetting ? 0 : 1 ,
            videollamada: this.form.value.videollamada ? 1 : 0 ,
            cantRooms: this.form.value.cantRooms,
            videocallTime: hora,
            
        };

        this._segmentsService.updateSegment(data).subscribe(
            data => {
                this.spinner.hide();
                this.toastr.success('El segmento se actualizo correctamente');
                this.getSegments()
            },
            error => {
                this.spinner.hide();
                this.toastr.error('Ocurrió un error, inténtalo de nuevo.', 'Error');
                this.logger.log(error);
            }
        );
    }

    onEdit(id: any) {
        this.segmentId = id;
        this.spinner.show();
        let idData = {
            Id: this.segmentId
        };
        // initialized the status
        this._segmentsService.getSegmentById(idData).subscribe(
            data => {
                
                if (data.status) {
                    this.form.reset();
                    this.form.setValue({
                        id: data.data.segments.id,
                        estado: data.data.segments.status,
                        ubicacion: data.data.segments.ubicacion,
                        nombre: data.data.segments.tienda,
                        defaultSetting: data.data.segments.defaultsetting == 1,
                        customSetting: data.data.segments.defaultsetting == 0 ,
                        videollamada: data.data.segments.videocall == 1 ,
                        cantRooms: data.data.segments.cantRooms,
                        timeCallHora: data.data.segments.timeCallHora,
                        timeCallMinuto: data.data.segments.timeCallMinuto,
                        timeCallSegundo:data.data.segments.timeCallSegundo,
                    });

                    
                    $('#updateSegment').modal('toggle', { backdrop: false });
                    $('#updateSegment').appendTo("body");
                    this.spinner.hide();
                } else {
                    this.toastr.error(data.message, 'Error');
                    this.spinner.hide();
                }

            },
            error => {
                this.spinner.hide();
                this.toastr.error('Ocurrió un error, inténtalo de nuevo.', 'Error');
                this.logger.log(error);

            }
        );
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }


    onFileChange(ev) {
        const file = ev.target.files[0];
        
        if (!file) {
            // No se ha seleccionado ningún archivo
            console.error("No se ha seleccionado ningún archivo.");
            return;
        }
        
        // Comprobar si el archivo es un archivo Excel
        if (!file.name.endsWith(".xlsx") && !file.name.endsWith(".xls")) {
            console.error("Por favor, seleccione un archivo Excel válido.");
            return;
        }
    
        const reader = new FileReader();
        reader.onload = (event) => {
            const data = reader.result;
    
            // Convertir el archivo Excel a JSON
            const workBook = XLSX.read(data, { type: 'binary' });
            const jsonData = workBook.SheetNames.reduce((initial, name) => {
                const sheet = workBook.Sheets[name];
                initial[name] = XLSX.utils.sheet_to_json(sheet);
                return initial;
            }, {});
    
            // Enviar los datos JSON al backend
            const dataString = JSON.stringify(jsonData);
            console.log("Datos del archivo Excel cargado: ", dataString);
    
            this.spinner.show();
            const dataJs = { dataExcel: dataString };
            this._segmentsService.uploadfiles(dataJs).subscribe(
                (response) => {
                    if (response.status) {
                        console.log(response);
                        if (response.message == 'failed') {
                            this.toastr.error('Estructura del archivo incorrecta', 'Error');
                        } else {
                            this.getSegments();
                            this.toastr.success('Archivo cargado correctamente', 'Éxito');
                        }
                    } else {
                        this.toastr.error(response.message, 'Error');
                    }
                    this.spinner.hide();
                },
                (error) => {
                    console.error("Error al enviar datos al backend:", error);
                    this.toastr.error('Error al cargar el archivo', 'Error');
                    this.spinner.hide();
                }
            );
        };
        reader.readAsBinaryString(file);
    }
    
    setDownload(data) {
        this.willDownload = true;
        setTimeout(() => {
            const el = document.querySelector("#download");
            el.setAttribute("href", `data:text/json;charset=utf-8,${encodeURIComponent(data)}`);
            el.setAttribute("download", 'xlsxtojson.json');
        }, 1000)
    }

    async exportAsXLSX(){

        const fileName = 'tablaSegmentos.xlsx';
        const data = await this._segmentsService.getSegments();
        this.segments = [...data.data.segments];
        this.userService.exportAsExcelFile(this.segments, fileName);
    }


}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/segments/segments/segments.component.ts